import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()
const FONDO_FIJO="fondo_fijo"

//courseG
export const courseGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(FONDO_FIJO,{params,signal:controller.signal})
    return {call,controller}
}
export const fondoFijoPost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(FONDO_FIJO,data,{params,signal:controller.signal})
    return {call,controller}
}
export const fondoFijoIdPost = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${FONDO_FIJO}/${id}`,data,{params,signal:controller.signal})
    return {call,controller}
}
